import { action, createRequestTypes } from '@/utils/actions.utils'
import { catalogsService } from '@/services'

export const FETCH_CATALOGS = createRequestTypes('FETCH_CATALOGS')
const fetchCatalogs = () => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await catalogsService.fetchCatalogs()

			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(FETCH_CATALOGS.REQUEST)
	}
	function success(payload) {
		return action(FETCH_CATALOGS.SUCCESS, payload)
	}
	function failure(err) {
		return action(FETCH_CATALOGS.FAILURE, null, err)
	}
}

export const SELECT_CATALOG = 'SELECT_CATALOG'
const selectCatalog = (catalogId) => {
	return {
		type: SELECT_CATALOG,
		payload: { catalogId }
	}
}

export const GET_DEFAULT_CATALOG = createRequestTypes('GET_DEFAULT_CATALOG')
const getDefaultCatalog = () => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const response = await catalogsService.getIpClient()
			const res = await catalogsService.getDefaultCatalog(response.data.ip)

			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(GET_DEFAULT_CATALOG.REQUEST)
	}
	function success(payload) {
		return action(GET_DEFAULT_CATALOG.SUCCESS, payload)
	}
	function failure(err) {
		return action(GET_DEFAULT_CATALOG.FAILURE, null, err)
	}
}

export default {
	fetchCatalogs,
	selectCatalog,
	getDefaultCatalog
}
